/** Ночь снимка: базовые цены и провенанс проставлены только у проверенных каналов. */
export type ChannelRateNight = {
  stay_date: string
  room_price: string
  room_price_base: string | null
  extra_bed_price: string
  extra_bed_price_base: string | null
  meal_type: number | null
  source_price_id: number | null
}

/**
 * Ставка, сообщённая каналом бронирования (наш портал — такой же канал), KNM-152.
 * У заявок, созданных до релиза, поле пустое.
 */
export type ChannelRate = {
  version: number
  captured_at: string
  currency: string
  channel: {
    slug: string
    name: string
    booking_id: string | null
    /** Цена сверена с нашим прайсом. У внешних каналов всегда false. */
    is_verified: boolean
  }
  stay: {
    checkin_date: string
    checkout_date: string
    nights_qty: number
    adults: number
    children: number
    children_ages: string | null
    guests: number
  }
  room: {
    room_category_id: number | null
    room_category_name: string | null
  }
  rate_plan: {
    id: number | null
    name: string | null
    meal_plan: string | null
  }
  extra_beds_qty: number
  nights: ChannelRateNight[]
  totals: {
    room_total: string
    extra_bed_total: string
    grand_total: string
    /** Цена до акции. null — скидки не было. */
    grand_total_base: string | null
    /** Комиссия канала. Для заявок с нашего портала всегда null. */
    commission: string | null
  }
}

export type TouristRequest = {
  id: number
  channel_rate: ChannelRate | null
  uuid: string
  accomodation: number
  accomodation_name: string
  room: number
  room_category: number
  room_name: string
  room_category_name: string
  checkin_date: string
  checkout_date: string
  phone: string | null
  email: string
  username: string
  contact_person: string
  adults: number
  children: number
  children_ages: string
  is_thread_hidden: boolean
  message_total_count: number
  message_unread_count: number
  create_date: string
}


export type GetRequestsResp = {
  count: number
  next: null | string
  previous: null | string
  total_pages: number
  results: TouristRequest[]
}

export type GetRequestsReq = {
  page: number
  per_page: number
  hidden?: boolean
  checkout_date__gt?: string
  has_unread_messages?: boolean
}

export const GET_TOURIST_REQUESTS = 'v2/pms/tourist_requests/'

export const GET_TOURIST_REQUESTS_COUNT = 'v2/pms/tourist_requests/statistic/'

export type GetRequestsCountResp = {
  all: number
  actual: number
  unread: number
}


export type Message = {
  id: number
  message: string
  create_date: string
  send_date: string
  is_readed: boolean
  is_from_tourist: boolean
}

export type GetRequestResp = TouristRequest & {
  messages: Message[]
}

export const GET_TOURIST_REQUEST = 'v2/pms/tourist_requests/:request_id/'
